
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

export const VitalSignsSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  const vitalFields = [
    { name: "vitalSigns.heightCm", label: "child-patient-assessment.height-cm" },
    { name: "vitalSigns.weightKg", label: "child-patient-assessment.weight-kg" },
    { name: "vitalSigns.temperatureC", label: "child-patient-assessment.temperature-c" },
    { name: "vitalSigns.pulsePerMinute", label: "child-patient-assessment.pulse-per-minute" },
    { name: "vitalSigns.spo2Percent", label: "child-patient-assessment.spo2-percent" },
  ];

  return (
    <Grid container spacing={2}>
      {vitalFields.map((field) => (
        <Grid key={field.name} md={2} xs={6}>
          <ByzTitleAndInputBox marginLeft="0px" title={t(field.label)}>
            <Controller
              name={field.name}
              control={control}
              render={({ field: controllerField }) => (
                <ByzMuiTextField {...controllerField} sx={{ pt: 1, width: "100%" }} />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
      ))}
    </Grid>
  );
};
